/**
 * 深邃蓝模板 - 详情页
 */

import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { getListingDetail } from "@/utils/api";
import { useSiteConfig } from "@/context/SiteConfigContext";
import DeepBlueNavbar from "../components/Navbar";
import DeepBlueFooter from "../components/Footer";

export default function ListingDetail() {
  const { id } = useParams<{ id: string }>();
  const { siteConfig } = useSiteConfig();
  const [listing, setListing] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    getListingDetail(id).then(d => setListing(d)).catch(() => {}).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="min-h-screen bg-gray-50 flex items-center justify-center"><i className="ri-loader-4-line animate-spin text-3xl text-blue-600" /></div>;
  if (!listing) return <div className="min-h-screen bg-gray-50 flex items-center justify-center text-gray-400">信息不存在</div>;

  return (
    <div className="min-h-screen bg-gray-50">
      <DeepBlueNavbar />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6">
        <Link to="/category" className="inline-flex items-center gap-1 text-sm text-gray-400 hover:text-blue-600 mb-6">
          <i className="ri-arrow-left-line" />返回列表
        </Link>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="p-6 sm:p-8">
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-3">
                  {listing.category_name && <span className="bg-blue-50 text-blue-700 px-2.5 py-0.5 rounded text-xs font-medium">{listing.category_name}</span>}
                  <span className="text-xs text-gray-400"><i className="ri-time-line mr-0.5" />{listing.created_at}</span>
                </div>
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6">{listing.title}</h1>

                {/* 服务详情 */}
                <div className="bg-gray-50/80 rounded-xl p-5 sm:p-6 mb-6 border border-gray-100">
                  <h3 className="text-sm font-semibold text-gray-700 mb-4 flex items-center gap-2">
                    <i className="ri-file-text-line text-blue-600" />服务详情
                  </h3>
                  <div className="prose max-w-none text-gray-600 leading-relaxed">
                    {(listing.content || "").split('\n').map((p: string, i: number) => <p key={i} className="mb-3">{p}</p>)}
                  </div>

                  {/* 图片展示 - 内容下方竖排 */}
                  {listing.images && listing.images.length > 0 && (
                    <div className="mt-6 pt-5 border-t border-gray-200">
                      <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3 flex items-center gap-1.5">
                        <i className="ri-image-line" />图片展示
                      </h4>
                      <div className="flex flex-col gap-3">
                        {listing.images.map((img: string, idx: number) => (
                          <img key={idx} src={img} alt={`${listing.title} - 图片${idx + 1}`}
                            className="w-full h-auto rounded-xl object-contain border border-gray-100 shadow-sm" />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="lg:w-64 shrink-0">
                <div className="border border-blue-100 rounded-xl p-5 bg-blue-50/30">
                  <h3 className="text-sm font-semibold text-gray-800 mb-3 flex items-center gap-2"><i className="ri-information-line text-blue-600" />详细信息</h3>
                  <div className="space-y-3 text-sm">
                    {listing.contact_name && <div><span className="text-gray-400 text-xs">联系人</span><p className="text-gray-700">{listing.contact_name}</p></div>}
                    {listing.contact_phone && <div><span className="text-gray-400 text-xs">电话</span><p className="text-gray-700">{listing.contact_phone}</p></div>}
                    {listing.contact_wechat && <div><span className="text-gray-400 text-xs">微信</span><p className="text-gray-700 break-all">{listing.contact_wechat}</p></div>}
                    {listing.company_name && !siteConfig?.hide_company_name && <div><span className="text-gray-400 text-xs">公司</span><p className="text-gray-700">{listing.company_name}</p></div>}
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-3 mt-6 pt-6 border-t border-gray-100 text-xs text-gray-400">
              <span><i className="ri-eye-line mr-0.5" />{listing.view_count || 0} 次浏览</span>
            </div>
          </div>
        </div>
      </div>

      <DeepBlueFooter />
    </div>
  );
}
